import App from 'app/app.js';

function LtAutoSrcDirective() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      attrs.$observe('ltAutoSrc', function (ltAutoSrc) {
        var src = ltAutoSrc,
          width = element.width(),
          height = element.height();

        if (width) {
          src = src + '?w=' + width;
        } else if (height) {
          src = src + '?h=' + height;
        }
        element.attr('src', src);
      });
    }
  };
}

App.directive('ltAutoSrc', LtAutoSrcDirective);
